import { Table, Button, Space, Input, Tooltip, DatePicker } from 'antd';
import { useState, useEffect } from 'react';
import fetchApi from '../../utils/api/fetchApi'
import antMessage from '../../utils/extend/AntdNotification'
import system from '../../config/systematic';
import survey from '../../generalMethod/survey';
import entrepotPrint from '../../generalMethod/entrepotPrint';
import { showCustomNotification, useNotificationInstance } from '../../utils/extend/AntdNotificationEx';
import DownloadExcel from '../report/DownloadExcel';
/** serviceIdType */
// export declare type serviceIdType = 'bm' | 'pay' | 'message';

// export const getService = (serviceId: string) => {
//     /** 默认service */
//     var defaultService = systematic.bmService
//     if (serviceId) {
//         switch (serviceId) {
//             case 'pay':
//                 defaultService = systematic.payService
//                 break;
//             case 'message':
//                 defaultService = systematic.messageService
//                 break;
//         }
//     }
//     return defaultService;
// };
/** WebUniversal ExtendProps数据类型 */
export declare type WUExtendPropsType = {

    /** 编辑组件 */
    EditComponent?: any,


    /** api服务id */
    apiId: string,
    /**apiExtend */
    apiExtend: string,
    isDownloadExcel?: boolean,
    /** 主键名称 */
    primaryKeyName?: string,
    showOperation?: boolean,
    showPrint?: boolean,
    /** 表头 */
    columns: Array<any>,
    isSummary?: boolean,

    /**参数 */
    values: any,

    typeProducts: string,
    pagination: boolean,
    printType: string,
    printApi: string,
    forcedRefresh?: boolean,
    setPaRows?: any
};

/** 刷新数据的类型 */
export declare type initDataType = {
    /** 服务id */
    apiId?: string,
    /** 页面传送的数据 */
    sendPageData?: any
};



/**
 * 通用Web组件 WebUniversal 
 * @param props 参数对象
 * @param ref 返回的对象
 * @returns 
 */
let WebUniversal = (props: any, ref?: any) => {
    let extendProps: WUExtendPropsType;
    extendProps = props.props;
    const notificationApi = useNotificationInstance()

    let {
        isDownloadExcel,
        EditComponent,
        apiId,
        apiExtend,
        pagination,
        columns,
        values,
        primaryKeyName,
        typeProducts,
        printType,
        printApi,
        showOperation,
        showPrint,
        setPaRows,
        isSummary,
    } = extendProps;

    /** 后端数据wmService */
    const wmService = system.wmService;
    // showOperation = showOperation ? showOperation : true
    if (typeof showOperation === "undefined") { showOperation = true };
    if (typeof showPrint === "undefined") { showPrint = true };


    // showPrint
    const [current, setCurrent] = useState<number>(1)
    const [pageSize, setPageSize] = useState<number>(10)
    const [total, setTotal] = useState<number>(0);

    const [rows, setRows] = useState<Array<any>>([]);
    const [userExpand, setUserExpand] = useState<any>();
    const [initValues, setInitValues] = useState<any>(values);

    const [modalopen, setModalopen] = useState(false);


    const [modalData, setModalData] = useState({});
    /** 页面数据刷新状态 */
    let loading = false;


    const initData = (values: any, currentEx?: number, pageSizeEx?: number) => {
        fetchApi.GET(
            wmService,
            {
                apiId,
                apiExtend,
                apiData: {
                    ...values,
                    pageSize: pageSizeEx ? pageSizeEx : pageSize,
                    current: currentEx ? currentEx : current,
                    mountDataOptions: {
                        userMount: {
                            isDept: true,
                            isUserAreas: true,
                        }
                    },
                }
            }
        ).then(res => {



            //    console.log("res",res);

            setTotal(res.data.total)
            setPageSize(res.data.pageSize)
            setCurrent(res.data.current)
            setInitValues(values)
            setRows(res.data.rows)
            setUserExpand(res.data.userExpand)
            if (setPaRows) {
                setPaRows(res.data.rows)
            }
            showCustomNotification(notificationApi!, {
                type: 'success',
                message: "搜索成功",
                description: "success"
            });;
        }).catch((err) => {
            showCustomNotification(notificationApi!, {
                type: 'error',
                message: "失败",
                description: err?.message
            });;
            console.log("err", err);

        })
    }



    //打开[新增-编辑-复制]框


    // //子组件回调函数，关闭modal
    const onCloseModal = (state: boolean) => {
        setModalopen(false)
        if (state === true) {
            //刷新表格内容
            initData(initValues)
        }
    }

    //编辑
    const handleEdit = (type: string, recordData: any) => {

        let id = recordData.id;
        if (typeof primaryKeyName !== "undefined") {
            id = recordData[primaryKeyName]
        }
        openModal(type, id);
    };

    let sendData = {
        type: '',
        id: '',
        userExpand

    }
    //打开[新增-编辑-复制]框
    const openModal = (type: string, id: string, ep?: any) => {
        sendData.type = type;
        sendData.id = id;
        // sendData.sendPageData = sendPageData;
        // sendData.extendedParameter = ep ? ep : extendedParameter;
        setModalData(sendData);
        setModalopen(true);
    }


    // 表格分页属性
    const paginationProps = {
        showSizeChanger: true,
        pageSizeOptions: [10, 20, 50, 100, 500, 1000, 1500, 5000],
        showQuickJumper: false,
        showTotal: () => `共${total}条`,
        pageSize,
        current,
        total,
        onShowSizeChange: (current: number, pageSize: number) => changePageSize(pageSize, current),
        onChange: (current: number) => changePage(current, pageSize),
    };

    // 回调函数，切换页数
    const changePage = (current: number, pageSize: number) => {
        if (loading === false) {
            initData(initValues, current, pageSize);
            loading = true;
        }
    }

    // 回调函数,每页显示多少条
    const changePageSize = (pageSize: number, current: number) => {

        if (loading === false) {
            initData(initValues, current, pageSize)
            loading = true;
        }
    };

    useEffect(() => {
        if (values) {
            initData(values)
        }

    }, [values])


    /** 表头 */
    let operationColumns: Array<any> = [
        (showOperation ? {
            title: "打印",
            dataIndex: 'print',
            align: "center",
            render: (text: any, record: any) => (<Button disabled={record.orderState === 99 && record.orderStatus === 3 ? false : true} size='small' type='primary' onClick={() => entrepotPrint.printOrder({ type: printType, typeProducts, apiId: printApi, id: record[primaryKeyName!], entrepotId: record?.entrepotId })}>打印</Button>)
            // render: (text: any, record: any) => (<Button size='small' type='primary' onClick={() => entrepotPrint.printOrder({type:printType,typeProducts,apiId:printApi,id:record[primaryKeyName!],entrepotId:record?.entrepotId})}>打印</Button>)

            // printType, typeProducts, printApi, undefined, record[primaryKeyName!]
        } : {}),
        (showOperation ? {
            title: "操作",
            dataIndex: 'operation',
            render: (text: any, record: any) =>
                <Space size="small">
                    <Button size={"small"} type="text" onClick={() => handleEdit("VIEW", record)} >查看</Button>
                    <Button disabled={(printApi === "purchaseOrder" ? userExpand?.purOrderEdit : userExpand?.trOrderEdit) ? false : record.orderState !== 99 && record.orderStatus === 1 ? false : true} size={"small"} type="text" onClick={() => handleEdit("EDIT", record)}>编辑</Button>
                </Space>

        } : {})
        // {
        //     title: "操作",
        //     dataIndex: 'operation',
        //     render: (text: any, record: any) =>
        //         <Space size="small">
        //             <Button size={"small"} type="text" onClick={() => handleEdit("VIEW", record)} >查看</Button>
        //             <Button disabled={level === 1 ? false : record.orderState !== 99 && record.orderStatus === 1 ? false : true} size={"small"} type="text" onClick={() => handleEdit("EDIT", record)}>编辑</Button>
        //             {/* <Button size={"small"} type="text" onClick={()=>handleEdit("EDIT",record)}>编辑</Button> */}

        //         </Space>
        // },
    ]


    columns = columns.concat(operationColumns)
    return (
        <>
            {isDownloadExcel ? <Button onClick={() => DownloadExcel(rows, apiExtend, { ...initValues })}>下载EXCEL文件</Button> : ""}


            <Table
                id='table'
                rowKey={(record: any, index: any) => index}
                columns={columns}
                dataSource={rows}
                pagination={pagination === true ? paginationProps : false}
                size="small"
                summary={(pageData: any) => {
                    if (isSummary) {
                        let totalPrice = 0;
                        let totalBNum = 0;

                        if (pageData.length > 0) {
                            pageData.map((item: any) => {
                                if (item.totalPrice) totalPrice += item.totalPrice;
                                if (item.bNum) totalBNum += item.bNum;
                            })
                        }
                        return (
                            <Table.Summary fixed>
                                <Table.Summary.Row>
                                    <Table.Summary.Cell index={0}>合计</Table.Summary.Cell>

                                    <Table.Summary.Cell index={1}></Table.Summary.Cell>
                                    <Table.Summary.Cell index={2}></Table.Summary.Cell>
                                    <Table.Summary.Cell index={3}></Table.Summary.Cell>
                                    <Table.Summary.Cell index={4}></Table.Summary.Cell>
                                    <Table.Summary.Cell index={5}></Table.Summary.Cell>
                                    <Table.Summary.Cell index={6}></Table.Summary.Cell>
                                    <Table.Summary.Cell index={7}>{totalBNum ? totalBNum.toFixed(2) : 0}</Table.Summary.Cell>
                                    <Table.Summary.Cell index={8}></Table.Summary.Cell>
                                    <Table.Summary.Cell index={9}>{totalPrice ? totalPrice.toFixed(2) : 0}</Table.Summary.Cell>
                                    <Table.Summary.Cell index={10}></Table.Summary.Cell>
                                    <Table.Summary.Cell index={11}></Table.Summary.Cell>
                                    <Table.Summary.Cell index={12}></Table.Summary.Cell>


                                </Table.Summary.Row>
                            </Table.Summary>
                        )
                    }

                }}
            //
            />
            {modalopen ? (<EditComponent closeModal={onCloseModal} data={modalData} />) : null}

        </>
    )
}


export default WebUniversal
